import React, { useEffect, useState } from 'react';
import toastService from '../services/toastService';
import './ToastContainer.css';

const AUTO_DISMISS_MS = 4000;

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = toastService.subscribe((toast) => {
      setToasts((prev) => [...prev, toast]);

      window.setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, AUTO_DISMISS_MS);
    });

    return unsubscribe;
  }, []);

  const remove = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`} role="status">
          <div className="toast-message">{t.message}</div>
          <button className="toast-close" onClick={() => remove(t.id)} aria-label="Close">
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
